import {
  Dimensions,
  Image,
  Linking,
  StyleSheet,
  View,
  useWindowDimensions,
} from "react-native";
import React, { useEffect } from "react";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { router, useGlobalSearchParams, useSegments } from "expo-router";

import Buttons from "components/Buttons";
import Carousel from "react-native-reanimated-carousel";
import Pagination from "src/components/Pagination";
import { Svg } from "assets/svg";
import { TouchableOpacity } from "react-native-gesture-handler";
import VText from "components/VText";
import { memo } from "react";
import { useRouter } from "expo-router";
import { useState } from "react";

const isMobile = Dimensions.get("window").width <= 768;

const data = [
  {
    image: "https://vetirapp-images.s3.us-east-1.amazonaws.com/homepage.webp",
    title: "PERSONALIZED PRODUCT RECOMMENDATIONS",
  },
  {
    image: "https://vetirapp-images.s3.us-east-1.amazonaws.com/PDP.webp",
    title: "ACCESS TO RARE DESIGNER PIECES",
  },
  {
    image: "https://vetirapp-images.s3.us-east-1.amazonaws.com/Outfits.webp",
    title: "DIGITIZE YOUR PERSONAL CLOSET",
  },
  {
    image:
      "https://vetirapp-images.s3.us-east-1.amazonaws.com/New+Arrivals.webp",
    title: "SHOP THE LATEST LUXURY DESIGNER PIECES",
  },
  {
    image: "https://vetirapp-images.s3.us-east-1.amazonaws.com/Outfits.webp",
    title: "CREATE AND MANAGE OUTFITS",
  },
];

const DesktopOnlyWrapper = (props) => {
  const { width, height } = useWindowDimensions();
  const [activeIndex, setActiveIndex] = useState(0);
  const segments = useSegments();
  const global = useGlobalSearchParams();
  const router = useRouter();

  const userAgent =
    typeof navigator !== "undefined" ? navigator.userAgent : "Not available";
  // return (
  //     <View style={{ flex: 1 }}>
  //         {props.children}
  //     </View>
  // );
  if (
    segments?.find((o) =>
      ["privacy-policy", "privacy-policy-1", "terms-and-conditions"]?.includes(
        o
      )
    ) ||
    userAgent?.toLowerCase()?.includes("googlebot") ||
    userAgent?.toLowerCase()?.includes("smartphone") ||
    (width > height &&
      width / height > 1.3 &&
      height > 500 &&
      width > 1000 &&
      width / height < 2.5)
  ) {
    return <View style={{ flex: 1 }}>{props.children}</View>;
  }

  useEffect(() => {
    let active = true;
    let timeout;
    timeout = setTimeout(() => {
      if (
        active &&
        (isMobile ||
          (userAgent && userAgent?.includes("iPhone")) ||
          userAgent?.includes("iphone"))
      ) {
        if (segments?.find((o) => ["product"]?.includes(o)) && global?.id) {
          router.push(
            `https://vetir2.page.link/?link=https://${global?.id}&ofl=https://apps.apple.com/in/app/v%25C3%25AAtir/id6444030686&isi=6444030686&ibi=com.app.closet.stylist&utm_campaign=banner&cid=772444359144802918&_osl=https://vetir2.page.link/PWKGHzju5wFRDbaa7?_imcp%3D1&_imcp=1`
          );
        } else if (segments?.find((o) => ["checkout"]?.includes(o))) {
          router.push(
            `https://vetir2.page.link/?link=https://cart&ofl=https://apps.apple.com/in/app/v%25C3%25AAtir/id6444030686&isi=6444030686&ibi=com.app.closet.stylist&utm_campaign=banner&cid=772444359144802918&_osl=https://vetir2.page.link/PWKGHzju5wFRDbaa7?_imcp%3D1&_imcp=1`
          );
        } else if (
          !segments?.find((o) =>
            [
              "privacy-policy",
              "privacy-policy-1",
              "terms-and-conditions",
            ]?.includes(o)
          )
        ) {
          router.push("https://vetir2.page.link/PWKGHzju5wFRDbaa7?efr=1");
        }
      }
    }, 500);
    return () => {
      active = false;
      clearTimeout(timeout);
    };
  }, [segments, isMobile, global]);

  const _renderItem = ({ item, index }) => {
    const isActive = activeIndex === index;
    return (
      <Image
        source={item.image}
        accessibilityLabel={`White Glove Digitization Image ${index + 1}`}
        style={{ width: "100", height: "100%", opacity: isActive ? 1 : 0.5 }}
        resizeMode="contain"
      ></Image>
    );
  };

  return (
    <View
      style={[Styles.container, { width, height, backgroundColor: "black" }]}
    >
      <Image
        accessibilityLabel="Vêtir Logo"
        style={Styles.logo}
        source={Svg.vetirWhiteLogoSvg}
      />

      <View style={Styles.contentWapper}>
        <View style={{ alignItems: "center", paddingTop: 20 }}>
          <Carousel
            loop
            width={220}
            height={200}
            autoPlay={true}
            autoPlayInterval={2000}
            data={data}
            onConfigurePanGesture={(PanGesture) => {}}
            style={{ overflow: "visible" }}
            mode="parallax"
            modeConfig={{
              parallaxScrollingScale: 1,
              parallaxScrollingOffset: 100,
              parallaxAdjacentItemScale: 0.75,
            }}
            scrollAnimationDuration={1000}
            renderItem={_renderItem}
            onSnapToItem={(index) => setActiveIndex(index)}
            numberOfVisibleItems={3}
          />

          <VText
            style={{
              color: "white",
              fontSize: 10,
              fontFamily: "JosefinSans",
              paddingVertical: 20,
              paddingHorizontal: 20,
              letterSpacing: "17%",
            }}
          >
            {data[activeIndex]?.title}
          </VText>
          <Pagination
            backgroundColor="white"
            data={Array.isArray(data) ? data : []}
            selectedIndex={activeIndex}
            containerStyle={{
              width: "100px",
              marginTop: -spV(10),
              paddingVertical: 14,
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        </View>

        <VText style={Styles.headingStyle}>
          {" "}
          The Future of Personal Retail{" "}
        </VText>
        <VText style={Styles.infoTextStyle}>
          The only smart shopping platform that empowers the luxury experience
          through technology, stylists and brands in one personalized smart
          shopping experience.{" "}
        </VText>

        <Buttons
          containerStyle={{
            borderRadius: 0,
            width: 230,
            height: 60,
            padding: 0,
            marginBottom: 10,
            marginTop: 0,
            backgroundColor: "white",
          }}
          text="Experience on App"
          textStyle={{
            fontSize: 20,
            lineHeight: 32,
            fontWeight: "500",
            fontFamily: "JosefinSans",
            padding: 10,
            color: "black",
          }}
          onPress={() => {
            Linking.openURL(
              "https://apps.apple.com/in/app/v%C3%AAtir/id6444030686"
            );
          }}
        />
        <VText style={Styles.smallInfoTextGrey}>To experience it on web,</VText>
        <VText style={Styles.smallInfoTextGrey}>
          {" "}
          open our website from your desktop
        </VText>
      </View>

      <View style={Styles.FooterContainer}>
        <View style={Styles.FooterWapper}>
          <VText style={Styles.copyRightText}>
            {" "}
            © 2024 Vêtir. All Rights Reserved.
          </VText>
          <TouchableOpacity
            onPress={() =>
              (window.location.href = "https://vetirapp.com/privacy-policy")
            }
          >
            <VText style={Styles.copyRightText}>Privacy Policy</VText>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() =>
              (window.location.href =
                "https://vetirapp.com/terms-and-conditions")
            }
          >
            <VText style={Styles.copyRightText}>Terms and Conditions</VText>
          </TouchableOpacity>
          <View style={Styles.SocialLinksConatiner}>
            <TouchableOpacity
              onPress={() => {
                Linking.openURL("https://www.instagram.com/vetirapp");
              }}
            >
              <Image
                accessibilityLabel="Instagram"
                resizeMode="contain"
                style={Styles.IocnsStyles}
                source={Svg.instagramSvg}
              />
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => {
                Linking.openURL("https://www.tiktok.com/@vetirapp");
              }}
            >
              <Image
                accessibilityLabel="Tiktok"
                resizeMode="contain"
                style={Styles.IocnsStyles}
                source={Svg.tiktokSvg}
              />
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </View>
  );
};

const Styles = StyleSheet.create({
  container: {
    backgroundColor: "black",
    paddingVertical: 10,
    alignItems: "center",
    overflowY: "scroll",
    overflowX: "hidden",
  },
  contentWapper: {
    paddingTop: 15,
    justifyContent: "center",
    alignItems: "center",
    margin: "auto",
  },
  logo: {
    marginTop: 30,
    alignItems: "center",
  },
  headingStyle: {
    color: "white",
    fontFamily: "LibreBodoni",
    fontStyle: "italic",
    fontSize: 24,
    fontWeight: "400",
    textAlign: "center",
  },
  infoTextStyle: {
    color: "white",
    fontFamily: "JosefinSans",
    fontSize: 18,
    fontStyle: "normal",
    paddingVertical: 24,
    paddingHorizontal: 30,
    textAlign: "center",
    lineHeight: "26px",
  },
  buttonStyle: {
    backgroundColor: "white",
  },
  smallInfoTextGrey: {
    textAlign: "center",
    color: "grey",
    fontFamily: "JosefinSans",
    fontSize: 12,
    fontWeight: "400",
    paddingTop: 7,
    paddingBottom: 7,
    lineHeight: 8,
  },
  FooterContainer: {
    paddingTop: 20,
    paddingHorizontal: 30,
    marginBottom: 50,
    borderTopWidth: 2,
    width: "100%",
    position: "relative",
    bottom: 0,
  },
  FooterWapper: {
    borderTopWidth: 1,
    borderTopColor: "rgba(255, 255, 255, 0.3)",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingTop: 20,
  },
  copyRightText: {
    color: "white",
    fontFamily: "LibreBodoni",
    fontSize: 13,
    lineHeight: 16,
  },
  SocialLinksConatiner: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderTopWidth: 1,
  },
  IocnsStyles: {
    padding: 10,
    height: 15,
    marginHorizontal: 4,
  },
});

export default memo(DesktopOnlyWrapper);
